import { Decodable } from './_decodable';
import { StockMovement } from './stock-movement';

class ProductStockMovementItem extends Decodable {
    id?: number;
    stockMovementId?: number;
    unitId?: number;
    productId?: number;
    name?: string;
    quantity: number = 0;
    productCode?: string;
    productUnit?: string;
    unitName?: string;
    unitAbbr?: string;
    createdAt?: Date;
    updatedAt?: Date;
    stockMovement?: StockMovement;

    protected _map = {
        createdAt: (e: any) => this.parseDate(e),
        updatedAt: (e: any) => this.parseDate(e),
        stockMovement: (e: any) => StockMovement.parse(e),
    };
}

export { ProductStockMovementItem };
